export const numberWithCommas = (number) => {
  if (!number) {
    return 0
  }

  const formattedNumber = Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100

  return formattedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const formatCurrencyAmount = (amount, currency = '') => {
  const formattedAmount = `$${numberWithCommas(amount)}`

  return currency ? `${currency} ${formattedAmount}` : formattedAmount
}
